module.exports = __webpack_public_path__ + "static/media/match_ended.2f0c007c.svg";